module.exports = __webpack_public_path__ + "static/media/7.3a4413c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/phonics-detail/7.png
// module id = 696
// module chunks = 0